import { render } from "preact";
import { App } from "./App";
import "./index.css";

const root = document.getElementById("app");
if (!root) throw new Error("#app root missing");

// Register the service worker for installability. Offline reading is deferred.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      /* installability survives a failed SW; ignore */
    });
  });
}

render(<App />, root);
